import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { browserBuild, useReleases } from "@/api/releases";
export function ReleaseBadge({
  collapsed,
  onNavigate,
}: {
  collapsed: boolean;
  onNavigate?: () => void;
}) {
  const { t, i18n } = useTranslation();
  const { data } = useReleases();
  const date = data?.loaded
    ? new Date(data.loaded.deployedAt).toLocaleDateString(i18n.language)
    : null;
  const label =
    browserBuild.mode === "development"
      ? t("releases.dev")
      : browserBuild.mode === "untracked"
        ? t("releases.untracked")
        : (date ?? t("releases.pending"));
  return (
    <Link
      to="/releases"
      onClick={onNavigate}
      aria-label={t("releases.openVersion", { version: browserBuild.version })}
      title={`${t("releases.title")} · ${label}`}
      className="mt-1 flex items-center justify-center gap-2 rounded-sm px-1 py-1.5 text-xs text-ink-faint hover:bg-surface hover:text-brand focus-visible:outline-2 focus-visible:outline-brand"
    >
      <span className="font-mono tabular">
        {t("common.webVersion", { version: browserBuild.version })}
      </span>
      {!collapsed && <span className="truncate">· {label}</span>}
    </Link>
  );
}
